import React, {useCallback, useEffect, useState} from 'react'
import {useParams} from "react-router-dom";
import {get} from "../../../Network/Axios";
import {Loader, ScrollableDynamicTable, TOAST as Alert} from "../../../../retro";
import Moment from 'moment'

export default function Settings() {
	const {id} = useParams();
	let [loading, setLoading] = useState(true);
	const [search, setSearch] = useState({
		page: 0,
		sort: 'id',
		order: 'desc'
	})
	const [Data, SetData] = useState({
		total: 0,
		currentPage: 0,
		totalPages: 0,
		items: []
	})
	const loadPage = useCallback((search) => {
		get(`/accounts/account/${id}/bookings`, (e, r) => {
			if (r) {
				SetData({
					...r
				})
				setLoading(false)
			} else {
				Alert.handleError(e)
			}
		}, {
			offset: search.page,
			sort: search.sort,
			order: search.order,
		})
	}, [SetData])
	useEffect(() => {
		loadPage(search)
	}, [search])
	return (
		<>
			<div className="mt4">
				{
					loading ?
						<Loader/> :
						<div className="relative">
							<ScrollableDynamicTable
								setSearch={(search) => {
									setSearch({
										...search,
										page: 0
									})
								}} search={search}
								tableStyle={{
									borderSpacing: 0
								}}
								setPage={page => {
									setSearch({
										...search,
										page
									})
								}}
								data={{
									current: Data.currentPage,
									total: Data.totalPages,
									items: Data.items.map(item => {
										return {
											content: item,
											render: [
												{
													children: (
														<div>
															<p className="text">
																#{item.transId}
															</p>
															<p className="text-small text-light">
																{item.app}
															</p>
														</div>
													),
													weight: 2,
												},
												{
													weight: 1,
													children: <p title={item.provider} className="truncate">{item.provider}</p>
												},
												{
													weight: 1,
													title: Moment(item.date).format("DD MMM YYYY")
												},
												{
													weight: 1,
													title: item.category
												},
												{
													weight: 1,
													title: item.status
												},
												{
													weight: 1,
													title: `INR ${item.amount}`
												}
											]
										}
									})
								}} headers={[
								{
									weight: 2,
									title: "Details",
								},
								{
									weight: 1,
									title: "Provider",
								},
								{
									weight: 1,
									title: "Date",
								},
								{
									weight: 1,
									title: "Category",
								},
								{
									weight: 1,
									title: "Status",
								},
								{
									weight: 1,
									title: "Amount",
								}
							]}/>
						</div>
				}
			</div>
		</>
	)
}
